var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings", {
    staticClass: "column-content-settings image-settings",
    attrs: {
      title: _vm.resource("TemplateColumnImageSettings_Settings_Title"),
      region: "right",
      tooltip: _vm.tooltip
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("settings-media-picker", {
              staticClass: "form-group",
              attrs: {
                label: _vm.resource(
                  "TemplateColumnImageSettings_MediaId_Label"
                ),
                "media-id": _vm.model.mediaId
              },
              on: {
                "file-picked": function($event) {
                  _vm.model.mediaId = $event
                }
              }
            }),
            _vm._v(" "),
            _vm.hasImage
              ? _c("settings-media-cropper", {
                  staticClass: "form-group",
                  attrs: {
                    label: _vm.resource(
                      "TemplateManager_Shared_OpenMediaCropper_Button_Text"
                    ),
                    "media-id": _vm.model.mediaId
                  },
                  on: {
                    "image-cropped": function($event) {
                      return _vm.imageCropped($event.mediaId, $event.crop)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("settings-slider", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_Size_Label"),
                min: 0,
                max: 100,
                "value-suffix": "%"
              },
              model: {
                value: _vm.model.style.size,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "size", $$v)
                },
                expression: "model.style.size"
              }
            }),
            _vm._v(" "),
            _c("settings-position", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_Position_Label")
              },
              model: {
                value: _vm.model.style.position,
                callback: function($$v) {
                  _vm.$set(_vm.model.style, "position", $$v)
                },
                expression: "model.style.position"
              }
            }),
            _vm._v(" "),
            _c("settings-textbox", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_TooltipText_Label")
              },
              model: {
                value: _vm.model.tooltip,
                callback: function($$v) {
                  _vm.$set(_vm.model, "tooltip", $$v)
                },
                expression: "model.tooltip"
              }
            }),
            _vm._v(" "),
            _c("settings-textbox", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_Link_Label")
              },
              model: {
                value: _vm.model.link,
                callback: function($$v) {
                  _vm.$set(_vm.model, "link", $$v)
                },
                expression: "model.link"
              }
            }),
            _vm._v(" "),
            _c("settings-rotation", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_RotateImage_Label")
              },
              on: { rotate: _vm.addRotation }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }